<template>
  <div>
    <DjHeader />
    <div>
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
  defineOptions({
    name: 'Header',
  });
</script>
